import React, { Suspense, lazy } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Spinner from "../app/shared/Spinner";
import { UseConfigContext } from "./context/ConfigContext";
import { UseProfileContext } from "./context/ProfileContext";
import { checkBrokerPanelUser } from "../Util/helper_functions";
const BrokerPanelUserDashboard = lazy(() => import("./user-pages/dashboard/BrokerPanelUserDashboard"));
const Strategy = lazy(() => import("./user-pages/strategy/Strategy"));
const StrategyDetails = lazy(() => import("./user-pages/strategy/StrategyDetails"));
const MyStrategy = lazy(() => import("./user-pages/my-strategy/MyStrategy"));
const Wallet = lazy(() => import("./user-pages/wallet/Wallet"));
const Profile = lazy(() => import("./user-pages/profile/Profile"));
const DematConnected = lazy(() => import("./user-pages/DematConnected"));
const Demat = lazy(() => import("./user-pages/demat/Demat"));
const Referral = lazy(() => import("./user-pages/referral/Referral"));
const OrderHistory = lazy(() => import("./user-pages/order-history/OrderHistory"));
const ActivityLogs = lazy(() => import("./user-pages/activity-logs/ActivityLogs"));
const Login = lazy(() => import("../app/auth-pages/Login"));
const Registartion = lazy(() => import("../app/auth-pages/Registration"));
const ForgotPassword = lazy(() => import("../app/auth-pages/ForgotPassword"));
const LinkUserDashboard = lazy(() => import("./user-pages/dashboard/LinkUserDashbord"));
const JsonBridge = lazy(() => import("./user-pages/json-bridge/JsonBridge"));
const JsonBridgeSyntaxGenerator = lazy(() => import("./user-pages/json-bridge/JsonBridgeSyntaxGenerator"));
const JsonBridgeDetails = lazy(() => import("./user-pages/json-bridge/JsonBridgeDetails"));
const OrderManager = lazy(() => import("./user-pages/order-manager/OrderManager"));
const AppRoutes = () => {
	const location = useLocation();
	const noLayoutRoutes = ["/login", "/dematconnected", "/forgot-password", "/registration"];

	// Only call config context if NOT in no-layout route
	let configData = null;
	let profileData = null;
	if (!noLayoutRoutes.includes(location.pathname)) {
		const ctx = UseConfigContext();
		configData = ctx.configData;
		const profile = UseProfileContext();
		profileData = profile.profileData;
	}
	const is_broker_panel_user = checkBrokerPanelUser();

	return (
		<Suspense fallback={<Spinner />}>
			<Routes>
				<Route path="/dashboard" element={is_broker_panel_user ? <BrokerPanelUserDashboard /> : <LinkUserDashboard />} />
				<Route path="/login" element={<Login />} />
				<Route path="/registration" element={<Registartion />} />
				<Route path="/forgot-password" element={<ForgotPassword />} />
				<Route path="/dematconnected" element={<DematConnected />} />
				<Route path="/demat" element={<Demat />} />
				{is_broker_panel_user && (
					<>
						<Route path="/strategy" element={<Strategy />} />
						<Route path="/strategy/:strategy_id" element={<StrategyDetails />} />
						<Route path="/mystrategy" element={<MyStrategy />} />
						<Route path="/mystrategy/:strategy_id" element={<StrategyDetails />} />
						<Route path="/jsonbridge" element={<JsonBridge />} />
						<Route path="/jsonbridge/:json_bridge_id" element={<JsonBridgeDetails />} />
						<Route path="/jsonbridge/:json_bridge_id/syntaxgenerator" element={<JsonBridgeSyntaxGenerator />} />
						<Route path="/ordermanager" element={<OrderManager />} />
						{configData?.payment_enabled && (
							<>
								<Route path="/wallet" element={<Wallet />} />
								<Route path="/referral" element={<Referral />} />
							</>
						)}

					</>
				)}

				<Route path="/orderhistory" element={<OrderHistory />} />
				<Route path="/activitylogs" element={<ActivityLogs />} />
				<Route path="/profile" element={<Profile />} />
				{/* WHEN PAYMENT ENABLE THAN ACCESS  THIS ROUTE  */}

				<Route path="*" element={<Navigate to="/login" />} />
			</Routes>
		</Suspense>
	);
};

export default AppRoutes;
